import ScrollMagic from 'scrollmagic';
import 'slick-carousel';
import Testimonials from '../../../blocks/testimonials/testimonials';

$(() => {

    const testimonials = new Testimonials('.js-testimonials');

    const controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '.l-page__header',
        offset: 50,
        reverse: false
    })
    .setClassToggle('.l-page__header .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.b-about-projects',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.b-about-projects .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.b-about-solutions',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.b-about-solutions .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__testimonials',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.l-page__testimonials .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.b-clients',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.b-clients .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__get-now',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.l-page__get-now .js-animate', 'js-animate-loaded')
    .addTo(controller);

});



// WEBPACK FOOTER //
// ./app/scripts/pages/about/about.js